import NilaiPerolehanProduksiAsetApi from "./NilaiPerolehanProduksiAsetApi";

export default NilaiPerolehanProduksiAsetApi;
